var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusCircleWhite = function SvgPlusCircleWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 12,
    r: 10,
    transform: "rotate(-90 12.0001 12)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3346 11.3812L12.6193 11.3812L12.6193 7.66586C12.6193 7.50164 12.554 7.34413 12.4379 7.22801C12.3218 7.11188 12.1643 7.04664 12.0001 7.04664C11.8358 7.04664 11.6783 7.11188 11.5622 7.22801C11.4461 7.34413 11.3808 7.50164 11.3808 7.66586L11.3808 11.3812L7.66551 11.3812C7.50128 11.3812 7.34378 11.4464 7.22765 11.5626C7.11152 11.6787 7.04628 11.8362 7.04628 12.0004C7.04628 12.1646 7.11152 12.3221 7.22765 12.4383C7.34378 12.5544 7.50128 12.6196 7.66551 12.6196L11.3808 12.6196L11.3808 16.335C11.3808 16.4992 11.4461 16.6567 11.5622 16.7728C11.6783 16.8889 11.8358 16.9542 12.0001 16.9542C12.1643 16.9542 12.3218 16.8889 12.4379 16.7728C12.554 16.6567 12.6193 16.4992 12.6193 16.335L12.6193 12.6196L16.3346 12.6196C16.4988 12.6196 16.6563 12.5544 16.7725 12.4383C16.8886 12.3221 16.9538 12.1646 16.9538 12.0004C16.9538 11.8362 16.8886 11.6787 16.7725 11.5626C16.6563 11.4464 16.4988 11.3812 16.3346 11.3812Z",
    fill: "#2355FC",
    stroke: "#2355FC",
    strokeWidth: 0.6
  })));
};
export default SvgPlusCircleWhite;